import { render, staticRenderFns } from "./legacy.vue?vue&type=template&id=b6cc86d6"
import script from "./legacy.vue?vue&type=script&lang=ts"
export * from "./legacy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports